import { computed, ComputedRef, Ref } from 'vue'

// eslint-disable-next-line
const emailRegex = /^[a-z0-9]+[a-z0-9-_.]*[a-z0-9]+@[a-z0-9]+[a-z0-9-]*\.[a-z]{2,}(?:\.[a-z]{2,})*$/i;

const useIsEmailValid = (
  email: ComputedRef<string> | Ref<string>
): ComputedRef<boolean> => {
  // email should be a computed

  const isEmailValid: ComputedRef<boolean> = computed(() => {
    return !!email.value.toLowerCase().match(emailRegex)
  })

  return isEmailValid
}

export default useIsEmailValid
